// 家族の応答履歴を購読する hook
import { useCallback, useEffect, useState } from 'react';
import { ReactionLog } from '../types';
import {
  appendReactionDb,
  clearReactionsByFamily,
  loadReactionsByFamily,
  subscribeReactionChanges,
} from '../lib/db';
import { useAuth } from '../contexts/AuthContext';

export function useReactions(limit = 200) {
  const { family } = useAuth();
  const [reactions, setReactions] = useState<ReactionLog[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!family) {
      setReactions([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const list = await loadReactionsByFamily(family.id, limit);
    setReactions(list);
    setLoading(false);
  }, [family, limit]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    if (!family) return;
    const unsub = subscribeReactionChanges(family.id, () => {
      reload();
    });
    return unsub;
  }, [family, reload]);

  const append = useCallback(
    async (log: Omit<ReactionLog, 'id'>) => {
      if (!family) return;
      await appendReactionDb(log, family.id);
      await reload();
    },
    [family, reload]
  );

  const clearAll = useCallback(async () => {
    if (!family) return;
    await clearReactionsByFamily(family.id);
    await reload();
  }, [family, reload]);

  return { reactions, loading, reload, append, clearAll };
}
